import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { VehiclesView } from './vehicles.view';

/**
 * Routeur pour la gestion des véhicules
 * 
 * Ce routeur gère la navigation pour :
 * - Vue des véhicules (/vehicles)
 * 
 * Logique métier :
 * - Routage simple vers la vue des véhicules
 * - Pas de sous-routes complexes
 * - Composant unique pour tous les utilisateurs
 * 
 * @returns Composant React du routeur des véhicules
 */
export const VehiclesRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <VehiclesView />
        </Route>
      </Switch>
    </div>
  );
};
